import ReactDOM from 'react-dom';
import { App } from './App';
import { Environment } from './shared/environment';

if (Environment.CLARITY_PROJECT_ID) {
  const headTag = document.head;
  const clarityScript = document.createElement('script');

  clarityScript.type = 'text/javascript';
  clarityScript.innerHTML = `(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "${Environment.CLARITY_PROJECT_ID}");`;

  headTag.appendChild(clarityScript);
}

ReactDOM.render(<App />, document.getElementById('root'));
